import { useState, useEffect } from 'react';
import PlusIcon from '@rsuite/icons/Plus';
import SearchIcon from '@rsuite/icons/Search';
import debounce from 'lodash/debounce';
import api from '../../services/api';
import EditarCadastrarCupom from './EditarCadastrar';
import { formataDataSemHora } from '../../components/funcoes';
import { Container, InputGroup, Stack, Table } from 'rsuite';
import { useAuth } from '../../hooks/auth';
import { ContentHeader } from '../../components/ContentHeader';
import DuvidasButton from '../../components/DuvidasButton';
import { CustomInput } from '../../components/CustomInput';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { CustomButton } from '../../components/CustomButton';
import { CustomCell } from '../../components/CustomCell';
import { CustomHeaderCell } from '../../components/CustomHeaderCell';
import { FaTicketAlt } from 'react-icons/fa';

const { Column } = Table;

const Cupom = () => {
  const { id_empresa } = useAuth();
  const [buscar, setBuscar] = useState('');
  const [loading, setLoading] = useState(true);
  const [cupons, setCupons] = useState([]);
  const [cupom, setCupom] = useState(null);
  const [modal, setModal] = useState(false);
  const { theme } = useCustomTheme();

  const atualizar = async () => {
    await api
      .get(`cupom/listar/${id_empresa}`)
      .then((res) =>
        res.data.length > 0 ? setCupons(res.data) : setCupons([]),
      )
      .finally(() => {
        setLoading(false);
      });
  };

  const abrirDados = (x) => {
    setCupom(x);
    setModal(true);
  };

  const consultar = async (consulta) => {
    consulta = consulta.substring(4);
    if (consulta === '') {
      atualizar();
    } else {
      await api
        .post('cupom/listarPorNomeGestor', {
          IdEmpresa: id_empresa,
          Consulta: consulta,
        })
        .then((res) => {
          res.data.length > 0 ? setCupons(res.data) : setCupons([]);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const cadastrar = () => {
    setCupom(null);
    setModal(true);
  };

  const debounceSearch = debounce((valor) => {
    let instrucao = '';
    const value_lower = valor?.toLowerCase();

    instrucao += value_lower ? ` AND LOWER(Descricao) LIKE '%${value_lower}%'` : ``;
    consultar(instrucao);
    setBuscar(valor);
  }, 1000);

  useEffect(() => {
    debounceSearch(buscar ?? '');
  }, []);

  useEffect(() => {
    atualizar();
  }, []);

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Cupons"
        subtitle="Gerencie os cupons da sua empresa"
        icon={FaTicketAlt}
        secondComponent={
          <InputGroup inside style={{ width: '40vw', border: 'none' }}>
            <CustomInput onChange={debounceSearch} />
            <InputGroup.Addon>
              <SearchIcon color={theme.colors.textSecondary} />
            </InputGroup.Addon>
          </InputGroup>
        }
        thirdComponent={
          <Stack spacing={10}>
            <DuvidasButton tela="cupom" />
            <CustomButton appearance="primary" onClick={() => cadastrar()}>
              <PlusIcon style={{ marginRight: 6 }} />
              Adicionar Cupom
            </CustomButton>
          </Stack>
        }
      />

      <Table
        height={window.innerHeight - 60 - 90}
        bordered={true}
        loading={loading}
        data={cupons}
        width={'100%'}
        style={{
          overflowY: 'auto',
          borderColor: theme.colors.backgroundSecondary,
          backgroundColor: theme.colors.backgroundSecondary,
          color: theme.colors.textSecondary,
        }}
        locale={{
          emptyMessage: 'Nenhum cupom encontrado',
          loading: 'Carregando...',
        }}
      >
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          align="center"
          fixed
        >
          <CustomHeaderCell>Código</CustomHeaderCell>
          <CustomCell dataKey="Id" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={4}
        >
          <CustomHeaderCell>Descrição</CustomHeaderCell>
          <CustomCell dataKey="Descricao" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={2}
        >
          <CustomHeaderCell>Início</CustomHeaderCell>
          <CustomCell>
            {(rowData) => (
              <text>{formataDataSemHora(rowData.DataInicial)}</text>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={2}
        >
          <CustomHeaderCell>Fim</CustomHeaderCell>
          <CustomCell>
            {(rowData) => <text>{formataDataSemHora(rowData.DataFinal)}</text>}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Utilizados</CustomHeaderCell>
          <CustomCell dataKey="QtdUtilizado" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          fixed="right"
        >
          <CustomHeaderCell>Ativo</CustomHeaderCell>

          <CustomCell dataKey="Fim">
            {(rowData) => (
              <span style={{ padding: 0 }}>
                <CustomButton
                  appearance={rowData.Ativo ? 'primary' : 'ghost'}
                  style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 10px',
                  }}
                  onClick={() => {}}
                >
                  {rowData.Ativo ? 'Sim' : 'Não'}
                </CustomButton>
              </span>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          fixed="right"
        >
          <CustomHeaderCell>Opções</CustomHeaderCell>
          <CustomCell>
            {(rowData) => (
              <span>
                <CustomButton
                  color={theme.colors.warning}
                  appearance="ghost"
                  size="xs"
                  onClick={() => abrirDados(rowData)}
                >
                  Editar
                </CustomButton>
              </span>
            )}
          </CustomCell>
        </Column>
      </Table>
      {modal && (
        <EditarCadastrarCupom
          modal={modal}
          close={() => setModal(false)}
          cupom={cupom}
          setCupons={setCupons}
        />
      )}
    </Container>
  );
};

export default Cupom;
